import { Text } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { Description, List, ListEl, Note, Title } from './elements'

export const Indeed = () => {
  const {
    access: { locale: userLocale },
  } = useCurrentSession()
  return (
    <>
      <Title>{i18n.t('app_store_v2.integrations.indeed.description_view.title_1')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.indeed.description_view.description_1')}
      </Description>
      <Title>{i18n.t('app_store_v2.integrations.indeed.description_view.title_2')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.indeed.description_view.description_2')}
      </Description>
      <List>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.1')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.2')}</ListEl>
        <ListEl>
          {i18n.tView('app_store_v2.integrations.indeed.description_view.list_1.3', {
            link: (
              <a
                href={`https://indeed.force.com/employerSupport1/s/contactsupport?language=${userLocale}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {i18n.t('app_store_v2.integrations.indeed.description_view.list_1.link')}
              </a>
            ),
          })}
        </ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.4')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.5')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.6')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.indeed.description_view.list_1.7')}</ListEl>
      </List>
      <Note>
        {i18n.tView('app_store_v2.integrations.indeed.description_view.note_1', {
          note: (
            <Text size="300" weight="medium">
              {i18n.t('common.note')}
            </Text>
          ),
        })}
      </Note>
      <Description>
        {i18n.t('app_store_v2.integrations.indeed.description_view.description_3')}
      </Description>
      <HelpCenterLink name="publish_on_indeed">
        {i18n.t('app_store_v2.integrations.indeed.help_center')}
      </HelpCenterLink>
    </>
  )
}
